import { createSelector } from 'reselect';

import VolunteerTimeOff from './model';
import { VolunteerTimeOffMap } from './reducer';

const sortVolunteerTimeOff = (a: VolunteerTimeOff, b: VolunteerTimeOff): number => {
  if (a.startingAt > b.startingAt) {
    return -1;
  } else if (a.startingAt < b.startingAt) {
    return 1;
  }

  return 0;
};

export const selectVolunteerTimeOff = (state: any): VolunteerTimeOffMap =>
  state.get('entities').volunteerTimeOff;

export const selectVolunteerTimeOffByUser = createSelector(
  selectVolunteerTimeOff,
  (state: any, userId: string) => userId,
  (volunteerTimesOff, userId) =>
    volunteerTimesOff
      .filter((volunteerTimeOff) => volunteerTimeOff?.user === userId)
      .sort(sortVolunteerTimeOff)
);
